<template>
  <v-app>
    <v-main>
      <v-system-bar dark height="30" color="teal">
        <v-spacer></v-spacer>
        <span class="white--text">
          For emergency help contact DOH-NCMH 24/7 Crisis Hotline 1800-1888-1553
        </span>
        <v-spacer></v-spacer>
      </v-system-bar>
      <router-view></router-view>

      <!-- App-wide notification channel. Any component surfaces a message via
           the notification store (this.$store.dispatch('notification/...')). -->
      <v-snackbar
        :value="notification.show"
        @input="setShow"
        :color="notification.color"
        :timeout="notification.timeout"
        bottom
      >
        {{ notification.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="setShow(false)">Close</v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),

  computed: {
    notification() {
      return this.$store.state.notification;
    },
  },

  methods: {
    setShow(value) {
      this.$store.commit('notification/setShow', value);
    },
  },
};
</script>
